import { useState } from 'react';
import { BRAND } from '@tarot/shared';
import { apiPost } from '../../lib/api';

/**
 * 문의하기 폼 — POST /api/contact (Resend → BRAND.supportEmail).
 * 이메일은 답장을 원할 때만 선택 입력. 실패/미설정 시 직접 메일 링크로 폴백.
 */
export function ContactForm() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    if (busy || message.trim().length < 10) return;
    setBusy(true);
    setError(null);
    try {
      await apiPost<{ ok: true }>('/contact', { email: email.trim(), message: message.trim() });
      setDone(true);
    } catch {
      setError(`메일을 보내지 못했어요. 아래 주소로 직접 보내주세요.`);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p className="rounded-2xl border border-gold/30 bg-gold/10 p-5 text-center text-sm">
        문의가 접수됐어요 ✨ 답장 주소를 남기셨다면 확인 후 회신드릴게요.
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-2.5">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="답장 받을 이메일 (선택)"
        className="rounded-xl border border-white/15 bg-night-2 px-4 py-3 text-sm placeholder:text-moon-dim/60 focus:border-gold/60 focus:outline-none"
      />
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={5}
        maxLength={2000}
        placeholder="문의 내용을 적어주세요 (10자 이상)"
        className="resize-none rounded-xl border border-white/15 bg-night-2 px-4 py-3 text-sm placeholder:text-moon-dim/60 focus:border-gold/60 focus:outline-none"
      />
      <button
        onClick={submit}
        disabled={busy || message.trim().length < 10}
        className="rounded-xl bg-gold px-4 py-3 text-sm font-semibold text-night transition hover:bg-gold-deep disabled:opacity-40"
      >
        {busy ? '보내는 중…' : '문의 보내기'}
      </button>
      {error && <p className="text-sm text-red-300">⚠️ {error}</p>}
      <a
        href={`mailto:${BRAND.supportEmail}`}
        className="text-center text-xs text-moon-dim underline underline-offset-2 hover:text-moon"
      >
        메일 앱으로 직접 보내기 ({BRAND.supportEmail})
      </a>
      <p className="text-center text-[11px] text-moon-dim/60">
        남긴 이메일은 답장 용도로만 쓰이고 별도로 저장되지 않아요.
      </p>
    </div>
  );
}
